<template lang="pug">
  .column.is-11
    article.card.table-card
      header.card-header
        p.card-header-title Faturamentos Aguardando Aprovação a Vencer
      .card-content.is-paddingless
        b-table(
          v-bind:data="revenuesWaiting.data",
          v-bind:striped="true",
          v-bind:narrowed="false",
          v-bind:mobile-cards="false",
          v-bind:loading="revenuesWaiting.isLoading",
          v-bind:row-class="getRowClass"
        )
          template(slot-scope="props")
            b-table-column(label="Nome") {{props.row.name}}
            b-table-column(label="Tipo") {{props.row.type}}
            b-table-column(label="Valor") {{props.row.value | currency}}
            b-table-column(label="Data Vencimento") {{props.row.due_date | moment('DD/MM/YYYY')}}
            b-table-column(label="Status Análise")
              b-tag(v-bind:type="statusClass[props.row.payment.status]") {{ statusLabel[props.row.payment.status] }}
            b-table-column(centered label="Gerenciar Pagamento")
              b-tooltip(label="Alterar Pagamento do Faturamento" type="is-dark")
                router-link(v-bind:to="{name: 'paymentRevenueEdit', params: {id: props.row._id}}")
                  span &nbsp;&nbsp; #[b-icon(icon="edit" type="is-primary" size="is-small")]
          template(slot="empty")
            section.section
              .content.has-text-grey.has-text-centered
                p
                  b-icon(icon="sentiment_very_dissatisfied", size="is-large")
                p Nenhum dado.
</template>

<script>
  import DataNotification from './DataNotification'

  import RevenueService from '@/services/revenue.js'
  const {statusLabel, statusClass} = RevenueService

  export default {
    name: 'RevenuesWaiting',
    components: {DataNotification},
    data () {
      return {
        today: this.$moment().startOf('day').toISOString(),
        revenuesWaiting: {isLoading: false, data: []},
        statusLabel,
        statusClass
      }
    },
    async created () {
      this.fetchRevenuesWaiting()
    },
    methods: {
      getRowClass (row) {
        if (row.due_date <= this.today) return 'is-danger'
      },
      async fetchRevenuesWaiting (params) {
        let query = {payment: {paid: false, status: 'provision'}, limit: 20, sort: {due_date: 'asc'}}
        query = Object.assign(query, params)
        this.revenuesWaiting.isLoading = true
        const response = await RevenueService.query(query)
        this.revenuesWaiting.isLoading = false
        this.revenuesWaiting.data = response.body.revenues
      }
    }
  }
</script>

<style lang="sass" scoped>
  .table-card
    min-height: 15rem
</style>



// WEBPACK FOOTER //
// RevenuesWaiting.vue?542ebbce